import deepmerge from 'deepmerge';
import { LocaleWrapper } from '@empiriecom/module-components/IntlProvider';
import deAT from './de-AT.json';
import overrides from './overrides/de-AT.json';

const messages: LocaleWrapper = {
  'de-AT': deepmerge(deAT, overrides),
};

export default messages;
